import type { AdminCopy } from '../i18n'

const two = (n: number) => String(n).padStart(2, '0')

/** "3 October, 09:40" in local time, the form screens 11 and 12 draw. */
export function formatWhen(iso: string, copy: AdminCopy): string {
  const d = new Date(iso)
  return `${d.getDate()} ${copy.months[d.getMonth()]}, ${two(d.getHours())}:${two(d.getMinutes())}`
}

/** "4 Oct, 10:02", for the outcome line under a request row. */
export function formatWhenShort(iso: string, copy: AdminCopy): string {
  const d = new Date(iso)
  return `${d.getDate()} ${copy.monthsShort[d.getMonth()]}, ${two(d.getHours())}:${two(d.getMinutes())}`
}

/** Whole days until `iso`, rounded up, at least 1: an invitation in the list is still valid. */
export function daysUntil(iso: string, now: number = Date.now()): number {
  return Math.max(1, Math.ceil((new Date(iso).getTime() - now) / 86_400_000))
}

/** "9 Oct", the date the company list draws. */
export function formatDayShort(iso: string, copy: AdminCopy): string {
  const d = new Date(iso)
  return `${d.getDate()} ${copy.monthsShort[d.getMonth()]}`
}

/** "2 September", the date the company detail draws. */
export function formatDay(iso: string, copy: AdminCopy): string {
  const d = new Date(iso)
  return `${d.getDate()} ${copy.months[d.getMonth()]}`
}
